import { CompSectionCore } from '../core/section/comp'

export const CompSection = CompSectionCore
